"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.find.title': 'Attiva/Disattiva Ricerca Web',
    'shortcuts.find.description': 'Abilita o disabilita la funzionalità di ricerca web',
};
